// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {buildTransferPayload} from '../../../product/shared/services/build-transfer-payload';
import {getFileName} from '../../../shared/services/get-file-name';
import {getTransferResults} from '../../shared/repositories/index';
import {openFile} from '../../../shared/services/open-file';

export const exportToExcel = (accounts, language, layout, listId) =>

            async dispatch => {

                dispatch(busyCounter.increaseBusyCounter());
                const transferPayload = buildTransferPayload(accounts, 'EXCEL', language, layout, listId);

                try {

                    const response = await getTransferResults(transferPayload);

                    const fileName = getFileName(response);

                    const blob = await response.blob();

                    openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

                } catch (error) {

                } finally {

                    dispatch(busyCounter.decreaseBusyCounter());

                }

            };



// WEBPACK FOOTER //
// ./src/product/transfers/action-creators/export-to-excel.js